export const handleError = (error: any) => {
  if (error.response) {
    console.error('Server responded with an error:', error.response.data);
  } else if (error.request) {
    console.error('No response received from server:', error.request);
  } else {
    console.error('Error setting up the request:', error.message);
  }
};
